import { useTranslation } from "react-i18next";

const securityItems = [
  { key: "item1", icon: "ri-link" },
  { key: "item2", icon: "ri-star-line" },
  { key: "item3", icon: "ri-camera-line" },
  { key: "item4", icon: "ri-lock-line" },
];

export default function SecuritySection() {
  const { t } = useTranslation();

  return (
    <section className="w-full px-6 md:px-10 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-900">
            {t("security.title")}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t("security.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          {securityItems.map((item) => (
            <div
              key={item.key}
              className="bg-background-100 rounded-2xl p-6 flex gap-4"
            >
              <div className="w-10 h-10 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-secondary-600 text-lg`}></i>
              </div>
              <div>
                <h3 className="text-base font-bold text-foreground-900">{t(`security.${item.key}.title`)}</h3>
                <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{t(`security.${item.key}.desc`)}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}